// MARK: used in v2
export enum PaymentMethod {
  DebitCreditCard = 1,
  InstantEft,
  Free,
}

export const PAYMENT_METHOD_LABELS = {
  [PaymentMethod.DebitCreditCard]: `Pay with Credit / Debit Card`,
  [PaymentMethod.InstantEft]: `Instant EFT`,
  [PaymentMethod.Free]: `Free`,
}

export const CHECKOUT_STEPS: YocoCom.CheckoutStep[] = [
  {
    name: "Information",
    heading: "Contact information",
    path: "/checkout/info/",
  },
  {
    name: "Shipping",
    heading: "Shipping address",
    path: "/checkout/shipping/",
  },
  {
    name: "Payment",
    heading: "Payment",
    path: "/checkout/payment/",
  },
  {
    name: "Get paid",
    heading: "",
    path: "/checkout/confirm/",
  },
]
